import { PortalConfiguration } from "@/Interfaces";
import { logger } from "@/utils/logger";
import { useCallback } from "react";

const usePortalConfiguration = () => {
    const config = useCallback((): PortalConfiguration | null => {
        const temp = sessionStorage.getItem('PORTAL_CONFIG');
        try {
            return temp ? JSON.parse(temp) : null;
        } catch (error) {
            logger.error('Failed to parse portal configuration.', {
                error: error
            });
            return null;
        }
    }, []);

    return config;
};

export default usePortalConfiguration;